import { inject, ref, reactive, onActivated, onDeactivated } from 'vue';
import { useStore } from 'vuex';
import { PASSWORD_RECOVER } from "@/store/actions.type";
export default {
  name: 'PasswordRecover',

  setup() {
    const store = useStore();
    const logger = inject('logger');
    const componentState = reactive({
      isLoading: false,
      isRendered: false
    });
    onActivated(() => {
      componentState.isRendered = true;
    });
    onDeactivated(() => {
      componentState.isRendered = false;
    });
    const formState = reactive({
      isFormDone: false
    });
    const validationRules = {
      email: [{
        required: true,
        message: 'Adres email jest wymagany',
        trigger: 'blur'
      }, {
        type: 'email',
        message: 'Wprowadź poprawny adres email',
        trigger: 'blur'
      }]
    };
    const credentialsForm = ref();
    const credentials = reactive({
      email: ''
    });

    function validateCredentials() {
      credentialsForm.value.validate(valid => {
        if (!valid) return;
        recoverPassword();
      });
    }

    function recoverPassword() {
      componentState.isLoading = true;
      store.dispatch(PASSWORD_RECOVER, credentials).then(() => formState.isFormDone = true).catch(error => logger(error, 'warn')).finally(() => componentState.isLoading = false);
    }

    return {
      componentState,
      formState,
      validationRules,
      credentialsForm,
      credentials,
      validateCredentials
    };
  }

};